export const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M7 3v3" />
    <path d="M17 3v3" />
    <path d="M4 8h16" />
    <rect x="4" y="5" width="16" height="16" rx="2" />
  </svg>
);
